import { useChatWindowLogout } from './useChatWindow/useChatWindowLogout'
import { storageKeys } from '../config/StorageKeys'
import { useAllLocalStorage, useAllSessionStorage, useUser } from '@ztechapps/common.hook'

export const useUserLogout = () => {
  const { logout: logoutCore } = useUser()

  const localStorage = useAllLocalStorage()
  const sessionStorage = useAllSessionStorage()

  const chatLogout = useChatWindowLogout()

  return async () => {
    //clear both order-alert flags so the next login re-shows the banner and the dialog
    sessionStorage.remove(storageKeys.hideOrderAlert)
    localStorage.remove(storageKeys.orderAlertDialogShown)

    await chatLogout()

    await logoutCore(false)

    //do native redirect
    globalThis.window.location.href = '/account/login'
  }
}
